import { render } from "./Home.vue?vue&type=template&id=26df8522&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=26df8522&scoped=true&lang=css"
/* custom blocks */
import block0 from "./Home.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_83056b5b%2Fpackages%2Finsurer%2Fsrc%2Fviews%2FHome.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26df8522"]])

export default __exports__